<div class="my-3 my-md-5">
    <div class="container-fluid">
        <h1 class="page-title">Insurance List</h1>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-2 mt-2"><input class="form-control" [(ngModel)]="search" type="text"  placeholder="Search" /></div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='3' || myrole=='4'  || myrole=='5'">
                            <mat-select  placeholder="Bds"  [(ngModel)]="bd" (click)="setSearchValue('lead_owner')">
                                <input class="mySearchInput"
                                #ownerSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="ownerSearch">
                                <mat-option >All</mat-option>
                                <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='5'">
                            <mat-select  placeholder="Assigned to" [(ngModel)]="assigned_to">
                                <mat-option >All</mat-option>
                                <mat-option value="{{inbd.id}}" *ngFor="let inbd of insbds">{{inbd.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" >
                            <mat-select  placeholder="Circle" [(ngModel)]="circle">
                                <mat-option >All</mat-option>
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Treatment"  [(ngModel)]="treatment" (click)="setSearchValue('treatment')">
                                <input class="mySearchInput"
                                #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="treatmentSearch">
                                <mat-option >All</mat-option>
                                <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Status"  [(ngModel)]="lead_status" (click)="setSearchValue('lead_status')" multiple>
                                <input class="mySearchInput"
                                #lead_status_Search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_status')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="lead_status_Search">
                                <mat-option [value]="lstatus.id" *ngFor="let lstatus of leadallStatus">{{lstatus.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Insurance Status"  [(ngModel)]="insurance_status" >
                                <mat-option  >All</mat-option>
                                <mat-option [value]="0" >Pending</mat-option>
                                <mat-option [value]="1" >Approved</mat-option>
                                <mat-option [value]="2" >Rejected</mat-option>
                                <mat-option [value]="3" >Pre Auth Pending</mat-option>
                                <mat-option [value]="6" >Pre Approval Pending</mat-option>
                                <mat-option [value]="7" >Pre Approval Query</mat-option>
                                <mat-option [value]="8" >Pre Approval Approved</mat-option>
                                <mat-option [value]="9" >Final Approval Pending</mat-option>
                                <mat-option [value]="10" >Final Approval Query</mat-option>
                                <mat-option [value]="11" >Final Approval Approved</mat-option>
                            </mat-select>
                        </div>
                        <!-- <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Payment Mode" (selectionChange)="loadInsuranceList(0,perpage)" [(ngModel)]="payment_mode" multiple>
                                <mat-option value="Cash">Cash</mat-option>
                                <mat-option value="Cashless">Cashless</mat-option>
                                <mat-option value="Reimbursement">Reimbursement</mat-option>
                                <mat-option value="EMI">EMI</mat-option>
                            </mat-select>
                        </div> -->
                        <div class="col-sm-3.5 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>

                        <div class="col-sm-3.5 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Last Status Updated Date Range</mat-label>
                                <mat-date-range-input [rangePicker]="picker1">
                                    <input matStartDate #dateRangeStart1 placeholder="Start date">
                                    <input matEndDate #dateRangeEnd1 placeholder="End date" (dateChange)="dateRangeChange1(dateRangeStart1, dateRangeEnd1)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker1></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate2()">clear</mat-icon>
                        </div>

                        <div class="col-sm-3 mt-2">
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadInsuranceList(0,perpage)">
                                <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                                    class="fa fa-sync"></i> Reset Filters</button>
                        </div>

                        <div class="float-right mt-3" *ngIf="myrole=='1' || myrole=='4'">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" (change)="loadInsuranceList(0,perpage)" [(ngModel)]="showPendingInsuranceCard">
                                <span class="custom-control-label">Show Pending Insurance Card</span>
                              </label>
                        </div>
                    </div>
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadInsuranceList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                    <button *ngIf="myrole!='8'" type="button" class="btn btn-success ml-2" [disabled]="loading" (click)="exportInsuranceList()"><i class="fa fa-file-excel"></i> Export List</button>
                </div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped" id="excel-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Status</th>
                        <th>Lead Status</th>
                        <th class="tablefixcoloumn">Lead Name</th>
                        <th *ngIf="myrole!='18' && myrole!='4'">Lead Mobile</th>
                        <th>Lead Location</th>
                        <th>Circle</th>
                        <th>Lead Owner</th>
                        <th>Treatment</th>
                        <th>Admission Date</th>
                        <th>Policy Number</th>
                        <th>Insurance Company</th>
                        <th>TPA</th>
                        <th>Sum Insured</th>
                        <th>Balance Sum Insured</th>
                        <th>Room Rent</th>
                        <th>Room Type</th>
                        <th>Copay</th>
                        <th>Corporate</th>
                        <th>Employee ID</th>
                        <th>Insurance Remarks</th>
                        <th>Insurance</th>
                        <th>Pre-Approval</th>
                        <th>Prescription</th>
                        <th>Created Date</th>
                        <th *ngIf="myrole=='1' || myrole=='5'">Last Status Updated Date</th>
                        <th>Last Remark Date</th>
                        <th *ngIf="myrole=='1' || myrole=='5'">Approval Letter Number</th>
                        <th *ngIf="myrole=='1' || myrole=='5'">Claim Number</th>
                        <th *ngIf="myrole=='1' || myrole=='5'">Recovery Remarks</th>
                        <th *ngIf="myrole=='1' || myrole=='5'">Queries</th>
                        <th *ngIf="myrole=='1' || myrole=='5'">Disease Capping Details</th>
                        <th *ngIf="myrole=='1' || myrole=='5'">Insurance Hospital Amount</th>
                        <th *ngIf="insuranceAllAccess=='1' || myrole=='1'">Assigned To</th>
                        <th *ngIf="myrole=='1' || insuranceAllAccess=='1'">Assign To</th>
                        <th *ngIf="myrole=='1' || myrole=='5'">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let lead of leads;let index = index;">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <td>
                        	<span class="badge bg-green-light" *ngIf="lead.status=='0'">Pending</span>
                        	<span class="badge bg-azure-light" *ngIf="lead.status=='1'">Approved</span>
                          <span class="badge bg-red" *ngIf="lead.status=='2'">Rejected</span>
                          <span class="badge bg-green-light" *ngIf="lead.status=='3'">Pre Auth Pending</span>
                        	<span class="badge bg-yellow-light" *ngIf="lead.status=='4'">Pre Auth Query</span>
                          <span class="badge bg-azure-light" *ngIf="lead.status=='5'">Pre Auth Approved</span>
                          <span class="badge bg-green-light" *ngIf="lead.status=='6'">Pre Approval Pending</span>
                        	<span class="badge bg-yellow-light" *ngIf="lead.status=='7'">Pre Approval Query</span>
                          <span class="badge bg-azure-light" *ngIf="lead.status=='8'">Pre Approval Approved</span>
                          <span class="badge bg-green-light" *ngIf="lead.status=='9'">Final Approval Pending</span>
                        	<span class="badge bg-yellow-light" *ngIf="lead.status=='10'">Final Approval Query</span>
                          <span class="badge bg-azure-light" *ngIf="lead.status=='11'">Final Approval Approved</span>
                        </td>
                        <td><span class="badge bg-green-light">{{lead.lead_status_name}}</span></td>
                        <td class="tablefixcoloumn">{{lead.lead_name}}</td>
                        <td *ngIf="myrole!='18' && myrole!='4'">{{lead.mobile}}</td>
                        <td>{{lead.city_name}}</td>
                        <td>{{lead.circle_name}}</td>
                        <td>{{lead.bd_name}}</td>
                        <td>{{lead.treatment_name}}</td>
                        <td>
                            <span *ngIf="lead.preauth_arrival_date_time">{{lead.preauth_arrival_date_time*1000|date:'dd MMM, yyyy hh:mm aa'}}</span>
                        </td>
                        <td>{{lead.policy_number}}</td>
                        <td>{{lead.insurance_company}}</td>
                        <td>
                            {{lead.tpa}}
                        </td>
                        <td>
                            {{lead.sum_insured}}
                        </td>
                        <td>
                            {{lead.balance_sum_insured}}
                        </td>
                        <td>
                            {{lead.room_rent}}
                        </td>
                        <td>
                            {{getRoomCategory(lead.room)}}
                        </td>
                        <td>
                            <span *ngIf="lead.copay && (lead.copay != '1' && lead.copay!='0' && lead.copay!='NIL')">{{lead.copay}}%</span>
                            <span *ngIf="lead.copay=='NIL' || lead.copay=='1' || lead.copay=='0'">NIL</span>
                            <span *ngIf="!lead.copay">-</span>

                        </td>
                        <td>{{lead.corporate}}</td>
                        <td>{{lead.employee_id}}</td>
                        <td class="bg-red-lighter">{{lead.insurance_description}}</td>

                        <td>
                            <div *ngIf="lead.insurances_copy.length > 0; else noInsurance">
                                <span *ngFor="let insurance of lead.insurances_copy"><a href="{{sc3Url+insurance.insurances}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noInsurance>
                                Not uploaded
                            </ng-template>
                        </td>

                        <td>
                            <div *ngIf="lead.pre_approval_copy.length > 0; else nopreAuthCopy">
                                <span *ngFor="let insurance of lead.pre_approval_copy"><a href="{{sc3Url+insurance.pre_approval}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #nopreAuthCopy>
                                Not uploaded
                            </ng-template>
                        </td>

                        <td>
                            <div *ngIf="lead.prescriptionCopy.length > 0; else noprescriptionCopy">
                                <span *ngFor="let insurance of lead.prescriptionCopy"><a href="{{sc3Url+insurance.prescription}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noprescriptionCopy>
                                Not uploaded
                            </ng-template>
                        </td>

                        <td>
                            {{lead.created_at*1000|date:'dd MMM, yyyy hh:mm aa'}}
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='5'">
                            <span *ngIf="lead.last_status_updated_on">{{lead.last_status_updated_on*1000|date:'dd MMM, yyyy hh:mm aa'}}</span>
                            <span *ngIf="!lead.last_status_updated_on">-</span>
                        </td>
                        <td>
                            <span *ngIf="lead.last_remark_date">{{lead.last_remark_date*1000|date:'dd MMM, yyyy hh:mm aa'}}</span>
                            <span *ngIf="!lead.last_remark_date">-</span>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='5'">
                            <span *ngIf="lead.approval_number">{{lead.approval_number}}</span>
                            <span *ngIf="!lead.approval_number">-</span>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='5'">
                            <span *ngIf="lead.claim_number">{{lead.claim_number}}</span>
                            <span *ngIf="!lead.claim_number">-</span>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='5'">
                            <span *ngIf="lead.recovery_remark">{{lead.recovery_remark}}</span>
                            <span *ngIf="!lead.recovery_remark">-</span>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='5'">
                            <span *ngIf="lead.queries">{{lead.queries}}</span>
                            <span *ngIf="!lead.queries">-</span>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='5'" >
                            <span *ngIf="lead.disease_capping==1"><b>Disease Capping:</b> Not Applicable</span>
                            <span *ngIf="lead.disease_capping==2"><b>Disease Capping:</b> Applicable</span>
                            <span *ngIf="lead.disease_capping==2 && lead.disease_capping_amount > 0"><br /><b>Disease Capping Amount:</b> {{lead.disease_capping_amount}}</span>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='5'" >
                            <span [innerHTML]="lead.insurance_hospital_amount | safe:'html'"></span>
                        </td>
                        <!-- <td *ngIf="myrole=='1' || myrole=='5'">{{lead.claim_number}}</td>
                        <td *ngIf="myrole=='1' || myrole=='5'">{{lead.recovery_remark}}</td>
                        <td *ngIf="myrole=='1' || myrole=='5'">{{lead.queries}}</td> -->
                        <td *ngIf="insuranceAllAccess=='1' || myrole == '1'">
                            <span *ngIf="lead.assign_to">{{lead.assign_to}}</span>
                            <span *ngIf="!lead.assign_to">-</span>
                        </td>
                        <td *ngIf="myrole == '1' || insuranceAllAccess=='1'">
                            <div class="dropdown">
                               <button class="btn btn-secondary dropdown-toggle" type="button" id="{{lead.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                   Assign To
                               </button>
                               <div class="dropdown-menu">
                                   <a class="dropdown-item" *ngFor="let ins_user of insuranceUsers;" (click)="updateAssignee(ins_user.id, lead.id)"><i class="fa fa-user"></i> {{ins_user.name}} </a>
                               </div>
                           </div>
                       </td>
                        <td *ngIf="myrole=='1' || myrole=='5'">
                             <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{lead.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{lead.id}}">
                                    <a class="dropdown-item cursor-pointer" (click)="openInsuranceDialog(lead.lead_id)"><i class="fa fa-edit"></i> Update Insurance</a>
                                    <a *ngIf="myrole=='1' || loginuserId == '44' || loginuserId == '56' || loginuserId == '263' || loginuserId == '165'" class="dropdown-item cursor-pointer" (click)="openleadHistoryPopup(lead.id)"><i class="fa fa-book-open"></i> View History</a>
                                </div>
                            </div>
                        </td>

                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !leads.length">
                        <td colspan="20" ><i class="far fa-frown"></i> Insurance not found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


          </div>
</div>


<!------------For Show lead History------------------->
<!-- The Modal to view history -->
<div class="modal fade" id="myHistoryModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Update History</h4>
            <button type="button" class="close" (click)="closeHistoryPopup()"></button>
        </div>
        <div class="modal-body history_modal">
            <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
              <tbody>
                  <tr *ngFor="let updatedLog of updatedLodData">
                      <td class="no-padding-bottom">
                          <div class="small_text" [innerHTML]="updatedLog.message | safe:'html'"></div>
                          <div class="small text-muted small_text_creation">
                              <i class="fas fa-clock"></i> {{updatedLog.created_at*1000|date:'dMMM, yyyy H:mm aa'}}
                          </div>
                      </td>
                  </tr>
                  <tr *ngIf="!updatedLodData.length && history_loaded">
                      <td>No history found</td>
                  </tr>
                  <tr *ngIf="history_loading">
                      <td><i class="fa fa-spin fa-spinner"></i></td>
                  </tr>
              </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" (click)="closeHistoryPopup()">Close</button>
        </div>
      </div>
    </div>
  </div>